import { getToken, withAppContext } from "@ctsu/loader";
import { Footer } from "@ctsu/react-ctsu-ui";
import buildInfoLock from "components/buildInfo/buildInfoLock.json";
import Header from "components/header/Header";
import { useGetUserGroup } from "helpers/getAppConfig";
import React, { useEffect, useState } from "react";

import { NavSpine } from "@ctsu/nav-spine";
import CheckJobStatus from "components/@Institution/InstituionRosters/RosterDetail/CheckJobStatus";
import NotificationCenter from "components/common/NotificationCenter";
import Sticky from "components/common/Sticky";

import { Outlet, useLocation } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";

function getRandomkey() {
  const array = new Uint32Array(1);
  return crypto?.getRandomValues(array);
}
const buildInfo = {
  buildVersion: buildInfoLock.build_version,
  buildDate: buildInfoLock.build_date
};

function PageViews() {
  const location = useLocation();
  useEffect(() => {
    if ("ga" in window) {
      const { ga } = window;
      ga("set", "page", location.pathname);
      ga("send", "pageview");
    }
  }, [location]);

  return null;
}

function AppContent(props) {
  const { context, children } = props;
  const { application, session } = context;
  const userGroup = useGetUserGroup();
  const authenticated = session?.username && !!getToken();
  const [mainKey, setMainKey] = useState(getRandomkey());
  const location = useLocation();

  useEffect(() => {
    const handleReload = () =>
      setTimeout(() => {
        setMainKey(getRandomkey());
      }, 1000);
    window.addEventListener("popstate", handleReload);
    window.addEventListener("refresh", handleReload);
    return () => {
      window.removeEventListener("popstate", handleReload);
      window.removeEventListener("refresh", handleReload);
    };
  }, []);

  return (
    <main>
      {authenticated
        ? (
          <aside>
            <NavSpine
              userContext={session}
              appRoot={process.env.REACT_APP_ORIGIN}
              appName="ROSTERING"
              getToken={getToken}
              userName={session.username}
            />
          </aside>
        )
        : null}
      {context && application && (
        <section id="rostering-app-header">
          <Header key={mainKey} />
        </section>
      )}

      {authenticated && (
        <Sticky topOffset={42}>
          <CheckJobStatus />
        </Sticky>
      )}
      <section className="main app-body" data-path={location.pathname}>
        <div className="app-spacing">
          <ErrorBoundary>
            <div key={userGroup} className="app-body-content">
              <div key={mainKey}>
                {children}
              </div>
            </div>
            <Outlet />
            <NotificationCenter key={location.pathname} />
          </ErrorBoundary>
        </div>
      </section>

      <Footer
        dbName={application?.dbName || ""}
        buildInfo={buildInfo}
        releaseNotes="https://www.ctsu.org/Master/SimplePage.aspx?ckey=ROST-RELEASE-NOTES"
      />
      <PageViews />
    </main>
  );
}

export default withAppContext(AppContent);
